import React, { useEffect, useState } from "react";
import "./Banner-Management.scss";
import { useSearchParams } from "react-router-dom";
import useFullPageLoader from "common/UseFullPageLoader";
import { bannerListApi } from "services/banner-management";
import findSerialNumber from "utils/findSerialNumber";
import { FaEdit, FaRegTrashAlt, FaToggleOff, FaToggleOn } from "react-icons/fa";
import NotFound from "common/NotFound";
import AddBanner from "./AddBanner";
import EditBanner from "./EditBannerManagement";
import Pagination from "react-js-pagination";
import DeleteBanner from "./DeleteBanner";
import ChangeBannerStatus from "./ChangeBannerStatus";
import { userPlaceholder } from "assets/icons";
import { CustomModal } from "components/modals/ModalBox";

const BannerManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();

  const [selectedBannerDetail, setSelectedBannerDetail] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);

  const [fetchedBannerData, setFetchedBannerData] = useState([]);
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const total = +searchParams.get("total") || 1;
  const position = +searchParams.get("position") || 1;

  const bannerMgmtApiCall = async () => {
    try {
      onShow();

      const query = {
        page: activePage,
        limit: limit,
        position,
      };

      if (position) {
        query.position = position;
      }

      const {
        data: {
          data: { total, data },
          status,
          code,
          message,
        },
      } = await bannerListApi(query);

      if (status || code === 200) {
        setFetchedBannerData(data);

        const newParams = new URLSearchParams(searchParams);
        newParams.set("total", total);
        setSearchParams(newParams);
        console.log("message:--->", message);
      }
    } catch (error) {
      console.log("BAnner Data fetch error:---> ", error);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    bannerMgmtApiCall();
  }, [activePage, limit, position]);

  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };

  const [addBannerState, setAddBannerState] = useState(false);
  const [editBannerState, setEditBannerState] = useState(false);
  const [selectedEditState, setSelectedEditState] = useState("");

  const closeModel = () => {
    setAddBannerState(false);
    setEditBannerState(false);
    setSelectedBannerDetail({});
    setDeleteModal(false);
    setStatusModal(false);
  };

  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  const showImagePreviewHandler = (profile) => {
    setShowImagePreviewModel(true);
    setImagePreview(profile);
  };

  return (
    <div className="banner-management-parent">
      {loader}
      <div className="page_title">
        <h3>Banner Management</h3>
      </div>

      <div className="card">
        <div className="tabContainer">
          <div className="set_btn">
            <ul>
              {[
                { id: 11, name: "1st Banner", value: 1 },
                { id: 12, name: "2nd Banner", value: 2 },
                { id: 13, name: "3rd Banner", value: 3 },
                { id: 14, name: "4th Banner", value: 4 },
                { id: 15, name: "5th Banner", value: 5 },
              ].map((tabData) => (
                <li
                  key={tabData.id}
                  className={tabData.value === position ? "active" : "un-active"}
                  onClick={() => {
                    const willSetSearchParam = new URLSearchParams(searchParams);
                    willSetSearchParam.set("position", tabData.value);
                    willSetSearchParam.set("page", 1);
                    setSearchParams(willSetSearchParam);
                  }}
                >
                  {tabData.name}
                </li>
              ))}
            </ul>
            <button
              className="button"
              type="button"
              onClick={() => setAddBannerState(true)}
            >
              Add Banner
            </button>
          </div>
        </div>

        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Image</th>
                <th className="nowrap text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {fetchedBannerData && fetchedBannerData.length ? (
                fetchedBannerData?.map((mapProp, index) => (
                  <tr key={index}>
                    <td className="nowrap text-center">
                      {findSerialNumber(index, activePage, limit)}
                    </td>

                    <td className="nowrap text-center">
                      <img
                        src={mapProp?.image}
                        alt={`Banner image-${index}`}
                        className="td-img"
                        onClick={() => showImagePreviewHandler(mapProp?.image)}
                      />
                    </td>

                    <td className="nowrap text-center">
                      <div className="button-container">
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedBannerDetail(mapProp);
                            setStatusModal(true);
                          }}
                        >
                          {mapProp?.status === "ACTIVE" ? (
                            <FaToggleOn size={18} />
                          ) : (
                            <FaToggleOff size={18} />
                          )}
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setSelectedEditState(mapProp?._id);
                            setEditBannerState(true);
                          }}
                        >
                          <FaEdit />
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            setSelectedBannerDetail(mapProp);
                            setDeleteModal(true);
                          }}
                        >
                          <FaRegTrashAlt />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <NotFound
                  cols={7}
                  msg={"Banner data not found"}
                  onHide={onHide}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ------Image Preview Modal */}
      {showImagePreviewModel && (
        <CustomModal
          className={"sm image_preview_modal"}
          show={showImagePreviewModel}
          handleClose={() => {
            setImagePreview("");
            setShowImagePreviewModel(false);
          }}
        >
          <div className="image_preview">
            <img
              src={imagePreview || userPlaceholder}
              alt="user-profile-preview"
            />
          </div>
        </CustomModal>
      )}

      {/* ------Change Status Modal */}
      {statusModal && (
        <ChangeBannerStatus
          selectedBannerDetail={selectedBannerDetail}
          onClose={() => closeModel()}
          bannerMgmtApiCall={bannerMgmtApiCall}
          statusModal={statusModal}
        />
      )}

      {/* ------Add Banner Modal */}
      {addBannerState && (
        <AddBanner
          addBannerState={addBannerState}
          bannerMgmtApiCall={bannerMgmtApiCall}
          closeModel={closeModel}
          position={position}
        />
      )}

      {/* ------Edit Banner Modal */}
      {editBannerState && (
        <EditBanner
          editBannerState={editBannerState}
          bannerMgmtApiCall={bannerMgmtApiCall}
          closeModel={closeModel}
          position={position}
          selectedBanner={selectedEditState}
          total={total}
        />
      )}

      {/* ------Delete Banner Modal */}
      {deleteModal && (
        <DeleteBanner
          deleteModal={deleteModal}
          selectedBannerDetail={selectedBannerDetail}
          setFetchedBannerData={setFetchedBannerData}
          closeModel={closeModel}
        />
      )}

      {/* ------Pagination */}
      {total > limit && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BannerManagement;
